export default {
  namespaced: true,
  state: {
    /** 内容类型 **/
    CONTENT_TYPE: {
      ACTIVITY: 1, // 活动
      ACTIVITY_SIGN: "activity_sign", //活动签到
      ACTIVITY_WORK_DETAIL: "activity_work_detail", //作品详情
      RAFFLE: 2, // 抽奖
      VOTE: 3, // 投票
      LIVE: 4, // 直播
      NEWS: 5, // 新闻
      GALLERY: 6, // 图集
      SPECIAL: 7, // 专题
      AD: 8, // 广告
      VIDEO: 9, // 视频
      QUESTIONNAIRE: 10, // 问卷调查
      AUDIO: 11, // 音频
      LINK: 12, // 外链
      REPORT: 16, // 报料
      RE_QUESTION: 17, // 问答
      WE_MEDIA: "we-media", // 自媒体
      INVITE: "invite", // 邀请
      SPECIAL_CONTENT_LIST: "special_content_list", // 专题-更多稿件列表
      COLUMN: "column", // 专栏
    },
    PAGE:{
      ACTIVITY: "/activity_detail", // 活动详情
      ACTIVITY_SIGN: "/sign_in", //活动签到
      ACTIVITY_WORK_DETAIL: "entriy_detail", //作品详情
      RAFFLE: "/raffle_detail", // 抽奖详情
      VOTE: "/vote_detail", // 投票详情
      LIVE: "/live_detail", // 直播详情
      NEWS: "/news_detail", // 图文详情
      GALLERY: "/gallery_detail", // 图集详情
      SPECIAL: "/special_detail", // 专题首页
      AD: "/ad_detail", // 广告
      VIDEO: "/video_detail", // 视频详情
      SHORTVIDEO: "/short_video_detail", // 短视频详情
      QUESTIONNAIRE: "/questionnaire_detail", // 问卷调查
      ANSWER: "/answer_detail", // 答题
      AUDIO: "audio_detail", // 音频详情
      REPORT: "/report_detail", //报料详情
      RE_QUESTION: "/requestion_detail", // 问答详情
      WE_MEDIA: "/media_detail", // 自媒体详情
      INVITE: "invitation", // 邀请
      SPECIAL_CONTENT_LIST: "/special_more", //专题分类下内容列表页
      COLUMN: "/column_detail", // 专栏首页
    },
    nodeCode: process.env.VUE_APP_NODE_CODE, //企业code
    wxAppId: process.env.VUE_APP_WECHAT_APPID, //微信AppId
    authType: process.env.VUE_APP_AUTH_TYPE,
    clientId: process.env.VUE_APP_CLIENT_ID,
    clientSecret: process.env.VUE_APP_CLIENT_SECRET,
    shareUrl: process.env.VUE_APP_SHARE_URL, //分享页地址
    DOWNLOAD_URL: process.env.VUE_APP_DOWNLOAD_URL, //APP下载
    token: window.localStorage.getItem("accessToken"),
    userInfo: JSON.parse(window.localStorage.getItem("userInfo")),
  },
  mutations: {
    SET_TOKEN(state,data){
      state.token = data;
      window.localStorage.setItem("accessToken",data);
    },
    SET_USERINFO(state, data) {
      state.userInfo = data;
      localStorage.setItem("userInfo", JSON.stringify(data));
    }
  },
  actions: {
    setToken({commit},data){
      commit('SET_TOKEN', data)
    },
    setUserInfo({commit},data){
      commit('SET_USERINFO', data)
    }
  },
  modules: {
  }
}